import { POST } from "../../index";

export const selectAuthorizeMangerPage = (param) => POST("/v1/AuthorizeController/selectAuthorizeMangerPage", param);
export const InsertAuthorizeTerminal = (param) => POST("/v1/AuthorizeController/InsertAuthorizeTerminal", param);
export const deleteTerminalAuthorize = (param) => POST("/v1/AuthorizeController/deleteTerminalAuthorize", param);
export const selectAuthorizeByDriver = (param) => POST("/v1/AuthorizeController/selectAuthorizeByDriver", param);
export const syncTerminalAuthorize = (param) => POST("/v1/AuthorizeController/syncTerminalAuthorize", param);
export const driverAuthorizeSync = (param) => POST("/v1/AuthorizeController/driverAuthorizeSync", param);